// Une fois que la page est chargée
window.addEventListener("DOMContentLoaded", () => {
  /*** Sticky header dès le premier scroll ***/
  const header = document.querySelector(".section-header");
  // Récupération de la hauteur du header
  const headerHeight = header.offsetHeight;
  header.style.height = headerHeight + "px";

  if (window.scrollY > 0) {
    header.classList.add("sticky");
  }

  window.addEventListener("scroll", () => {
    if (window.scrollY > 0) {
      header.classList.add("sticky");
    } else {
      header.classList.remove("sticky");
    }
  });

  /*** Duplication du logo pour la transition sticky ***/
  // On fixe la hauteur du header
  // header.style.height = header.querySelector(".header_wrapper").offsetHeight + "px";

  // On crée un div de class "logo_sticky" qui contient le logo, on le place à la fin du header
  const logo_sticky = document.createElement("div");
  logo_sticky.classList.add("logo_sticky");
  logo_sticky.innerHTML = header.querySelector(".header_logo .header_title").innerHTML;
  header.querySelector(".header_wrapper").appendChild(logo_sticky);

  /*** Gestion des langues ***/
  const languageSelection_elements = document.querySelectorAll(".localization-form span");
  if (languageSelection_elements) {
    languageSelection_elements.forEach((element) => {
      element.addEventListener("click", (e) => {
        // prevent default
        e.preventDefault();

        // Change value of input hidden
        e.target.closest("form").querySelector("input[name='language_code']").value = e.target.dataset.language;

        // Submit le form parent
        e.target.closest("form").submit();
      });
    });
  }

  /*** Gestion du menu ***/
  // Au hover des divs ".header_menu_level_1", on ouvre le sous menu avec un effet de fade (en jouant sur l'opacité)
  const headerMenuLevel1_elements = document.querySelectorAll(".header_menu_level_1");
  if (headerMenuLevel1_elements) {
    headerMenuLevel1_elements.forEach((element) => {
      element.addEventListener("mouseenter", () => {
        if (window.innerWidth >= 1024) {
          // stop toutes les animations en cours
          $(element.querySelector(".header_menu_level_2")).stop(true, true);
          $(element.querySelector(".header_menu_level_2")).fadeIn(200);
        }
      });

      element.addEventListener("mouseleave", () => {
        // stop toutes les animations en cours
        if (window.innerWidth >= 1024) {
          $(element.querySelector(".header_menu_level_2")).stop(true, true);
          $(element.querySelector(".header_menu_level_2")).fadeOut(200);
        }
      });

      element.addEventListener("click", (e) => {
        // Si la target contient un aria-controls
        if (e.target.getAttribute("aria-controls")) {
          if (window.innerWidth < 1024) {
            e.preventDefault();
            if (element.querySelector(".header_menu_level_2").classList.contains("open")) {
              $(element.querySelector(".header_menu_level_2")).slideUp(200, function () {
                $(element.querySelector(".header_menu_level_2")).removeClass("open");
              });
            } else {
              $(element.querySelector(".header_menu_level_2")).addClass("open").hide().slideDown(200);
            }
          }
        }
      });
    });
  }

  /*** Gestion de l'ouverture du menu, click sur burger ***/
  const burger = document.querySelector(".burger");
  if (burger) {
    burger.addEventListener("click", () => {
      burger.setAttribute("aria-expanded", burger.getAttribute("aria-expanded") === "true" ? "false" : "true");
      $(".header_menu_overlay").fadeToggle(100, function () {
        if ($(".header_menu_overlay").is(":visible")) {
          $(".header_menu_overlay").addClass("open");
        } else {
          $(".header_menu_overlay").removeClass("open");
        }
      });
    });
  }

  /*** Gestion de la fermeture du menu, click sur l'overlay. Uniquement sur lui et pas sur les éléments enfants ***/
  const header_menu_overlay = document.querySelector(".header_menu_overlay");
  if (header_menu_overlay) {
    header_menu_overlay.addEventListener("click", (e) => {
      // si la target est .header_menu_overlay, on ferme le menu
      if (e.target === header_menu_overlay) {
        burger.setAttribute("aria-expanded", "false");
        $(".header_menu_overlay").fadeOut(100);
      }
    });
  }

  /*** Gestion de la recherche ***/
  const header_icon_search = document.querySelector(".header_icon_item.search");
  const header_search = document.querySelector(".header_search");
  if (header_icon_search && header_search) {
    // Ouverture
    header_icon_search.addEventListener("click", () => {
      $(header_search).slideDown(200, () => {
        header_search.querySelector("input").focus();
      });
    });

    // Fermeture
    header_search.querySelector(".header_search_close").addEventListener("click", () => {
      $(header_search).slideUp(200);
    });
  }

  /*** Tooltips ***/
  const tooltips_elements = document.querySelectorAll("[data-tooltip]");
  if (tooltips_elements) {
    tooltips_elements.forEach((element) => {
      element.addEventListener("mouseenter", () => {
        // stop toutes les animations en cours
        $(element.querySelector(".tooltip")).stop(true, true);
        $(element.querySelector(".tooltip")).show();
      });

      element.addEventListener("mouseleave", () => {
        // stop toutes les animations en cours
        $(element.querySelector(".tooltip")).stop(true, true);
        $(element.querySelector(".tooltip")).hide();
      });
    });
  }

  /*** Cart drawer ***/
  const header_icon_cart = document.querySelector(".header_icon_item.cart");
  const cart_drawer = document.querySelector(".cart_drawer");
  if (header_icon_cart && cart_drawer) {
    header_icon_cart.addEventListener("click", (e) => {
      e.preventDefault();

      // Ouverture de l'overlay
      $(cart_drawer.closest(".overlay_full")).fadeIn(100, () => {
        // Ouverture du drawer
        cart_drawer.setAttribute("data-state", "open");
      });
    });

    cart_drawer.closest(".overlay_full").addEventListener("click", (e) => {
      // si l'élément cliqué n'est pas .cart_drawer_overlay, ou .cart_drawer_wrapper, on ne fait rien
      if (!e.target.closest(".drawer") || e.target.closest(".drawer_header_close")) {
        cart_drawer.setAttribute("data-state", "closed");
        $(cart_drawer.closest(".overlay_full")).fadeOut(100);
      }
    });

    // Si on appuie sur la touche "Escape"
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        cart_drawer.setAttribute("data-state", "closed");
        $(cart_drawer.closest(".overlay_full")).fadeOut(100);
      }
    });
  }

  /*** Filter drawer ***/
  const filter_drawer_opener = document.querySelector(".results_control_filters_button");
  const filter_drawer = document.querySelector(".filter_drawer");

  if (filter_drawer_opener && filter_drawer) {
    filter_drawer_opener.addEventListener("click", (e) => {
      e.preventDefault();

      // Ouverture de l'overlay
      $(filter_drawer.closest(".overlay_full")).fadeIn(100, () => {
        // Ouverture du drawer
        filter_drawer.setAttribute("data-state", "open");
      });
    });

    filter_drawer.closest(".overlay_full").addEventListener("click", (e) => {
      // si l'élément cliqué n'est pas .filter_drawer_overlay, ou .filter_drawer_wrapper, on ne fait rien
      if (!e.target.closest(".drawer") || e.target.closest(".drawer_header_close")) {
        filter_drawer.setAttribute("data-state", "closed");
        $(filter_drawer.closest(".overlay_full")).fadeOut(100);
      }
    });

    // Si on appuie sur la touche "Escape"
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        filter_drawer.setAttribute("data-state", "closed");
        $(filter_drawer.closest(".overlay_full")).fadeOut(100);
      }
    });
  }
});

function isInViewport(element) {
  const rect = element.getBoundingClientRect();
  return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
}

/**
 * @description Debounce a function : Permet de grouper les appels à une fonction pour éviter les appels multiples en trop (cliquer trop vite sur un bouton par exemple)
 * @param {Function} fn - The function to debounce
 * @param {number} wait - The time to wait in milliseconds
 * @returns {Function}
 */
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

/**
 * @description Throttle a function : Permet de limiter le nombre d'appels à une fonction pour éviter les appels multiples en trop (cliquer trop vite sur un bouton par exemple)
 * @param {Function} fn - The function to throttle
 * @param {number} delay - The time to wait in milliseconds
 * @returns {Function}
 */

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

/**
 * @description Fetch config : Permet de configurer la requête fetch rapidement
 * @param {string} type - The type of the response
 * @returns {Object}
 */
function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: `application/${type}` },
  };
}

/*** Classes ***/
class filterForm extends HTMLElement {
  constructor() {
    super();

    this.debouncedOnSubmit = debounce((event) => {
      this.submitForm(event);
    }, 800);

    // Ecouteur sur changement formulaire
    const form = this.querySelector("form");
    if (form) {
      form.addEventListener("input", this.debouncedOnSubmit);
    }

    // Ecouteur de clic sur le bouton "Appliquer" (fermeture du drawer)
    const applyButton = this.querySelector(".filter_drawer_footer_apply");
    if (applyButton) {
      applyButton.addEventListener("click", () => {
        filter_drawer.setAttribute("data-state", "closed");
        $(filter_drawer.closest(".overlay_full")).fadeOut(100);
      });
    }

    // Ecouteur de clic sur le bouton "Supprimer les filtres" (remise à zéro du formulaire)
    const resetButton = this.querySelector(".filter_drawer_footer_reset");
    if (resetButton) {
      resetButton.addEventListener("click", (event) => {
        this.resetForm(event);
      });
    }

    // Ecouteur de clic sur le label des filtres
    const filterLabels = this.querySelectorAll(".filter_drawer_item_label");
    if (filterLabels) {
      filterLabels.forEach((label) => {
        label.addEventListener("click", (event) => {
          this.toggleFilter(event);
        });
      });
    }

    // Initialisation des filtres
    this.filterData = [];
  }

  connectedCallback() {}

  submitForm(event) {
    event.preventDefault();
    const searchParams = this.createSearchParams(event.target.closest("form"));
    this.renderResults(searchParams, event);
  }

  resetForm(event) {
    event.preventDefault();
    let url_base = "";
    this.renderResults(url_base, event, true, true);
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  updateURLHash(searchParams) {
    history.pushState({ searchParams }, "", `${window.location.pathname}${searchParams && "?".concat(searchParams)}`);
  }

  getSections() {
    return [
      {
        section: document.getElementById("collection_products_list").dataset.id,
      },
    ];
  }

  renderResults(searchParams, event, updateURLHash = true, updateDrawer = false) {
    const sections = this.getSections();

    /*** @todo : Placer ici si besoin d'un effet de loading
     * Ex : Ajouter une classe "loading" à la section
     * Fin de l'effet de loading ***/

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      this.renderSectionFromFetch(url, event, updateDrawer);
    });

    if (updateURLHash) this.updateURLHash(searchParams);
  }

  renderSectionFromFetch(url, event, updateDrawer = false) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        this.filterData = [...this.filterData, { html, url }];
        this.renderProductsList(html);
        this.renderProductCount(html);

        if (updateDrawer) {
          this.renderFilters(html, event);
        }
      });
  }

  renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, "text/html").querySelector(".filter_drawer_product_count").innerHTML;
    const container = document.querySelector(".filter_drawer_product_count");
    container.innerHTML = count;
  }

  renderFilters(html, event) {
    document.querySelector(".filter_drawer_content_items_list").innerHTML = new DOMParser().parseFromString(html, "text/html").querySelector(".filter_drawer_content_items_list").innerHTML;
  }

  renderProductsList(html) {
    document.getElementById("collection_products_list").innerHTML = new DOMParser().parseFromString(html, "text/html").getElementById("collection_products_list").innerHTML;
  }

  toggleFilter(event) {
    // On cherche le sibblings de la target de classe "filter_drawer_item_values_wrapper "
    const filter = event.target.closest(".filter_drawer_item").querySelector(".filter_drawer_item_values_wrapper");
    if (filter) {
      $(filter).slideToggle(200);
    }
  }
}

customElements.define("filter-form", filterForm);

/*** Gestion des recommandations produits ***/
/* class ProductRecommendations extends HTMLElement {
  observer = undefined;

  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeRecommendations(this.dataset.productId);
  }

  initializeRecommendations(productId) {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations(productId);
      },
      { rootMargin: "0px 0px 400px 0px" }
    );
    this.observer.observe(this);
  }

  loadRecommendations(productId) {
    fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement("div");
        html.innerHTML = text;
        const recommendations = html.querySelector("product-recommendations");

        if (recommendations?.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        if (!this.querySelector("slideshow-component") && this.classList.contains("complementary-products")) {
          this.remove();
        }

        if (html.querySelector(".grid__item")) {
          this.classList.add("product-recommendations--loaded");
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
} */
class ProductRecommendations extends HTMLElement {
  observer = undefined;

  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeRecommendations(this.dataset.productId);
  }

  initializeRecommendations(productId) {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations(productId);
      },
      { rootMargin: "0px 0px 400px 0px" }
    );
    this.observer.observe(this);
  }

  loadRecommendations(productId) {
    fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement("div");
        html.innerHTML = text;
        const recommendations = html.querySelector("product-recommendations #related_products");

        if (recommendations?.innerHTML.trim().length) {
          // this.innerHTML = recommendations.innerHTML;
          this.querySelector("#related_products").innerHTML = recommendations.innerHTML;
          this.querySelector("#related_products_title").style.display = "block";
        }

        /* if (!this.querySelector("slideshow-component") && this.classList.contains("complementary-products")) {
            this.remove();
          }

          if (html.querySelector(".grid__item")) {
            this.classList.add("product-recommendations--loaded");
          } */
      })
      .catch((e) => {
        console.error(e);
      });

    fetch(`${this.dataset.lookUrl}&product_id=${productId}&section_id=${this.dataset.sectionId}`)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement("div");
        html.innerHTML = text;
        const recommendations = html.querySelector("product-recommendations #complementary_products");

        if (recommendations?.innerHTML.trim().length) {
          this.querySelector("#complementary_products").innerHTML = recommendations.innerHTML;
          this.querySelector("#complementary_products_title").style.display = "block";
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}
customElements.define("product-recommendations", ProductRecommendations);

/*** Classes Utilitaires ***/
class HTMLUpdateUtility {
  /**
   * Used to swap an HTML node with a new node.
   * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
   *
   * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   */
  static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
    preProcessCallbacks?.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement("div");
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;

    // dedupe IDs
    const uniqueKey = Date.now();
    oldNode.querySelectorAll("[id], [form]").forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form && element.setAttribute("form", `${element.form.getAttribute("id")}-${uniqueKey}`);
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = "none";

    postProcessCallbacks?.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 500);
  }

  // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll("script").forEach((oldScriptTag) => {
      const newScriptTag = document.createElement("script");
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}

// Product card swiper
class ProductCardSwiper extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.generateSlideLinks();
    this.initializeSwiper();
  }

  generateSlideLinks() {
    this.querySelectorAll(".swiper-slide").forEach((slide) => {
      // On insère au début du .swiper-slide un lien avec l'url du produit
      slide.innerHTML = `<a href="${this.dataset.productUrl}">${slide.innerHTML}</a>`;
    });
  }

  initializeSwiper() {
    new Swiper(this.querySelector(".swiper"), {
      loop: true,
      slidesPerView: 1,
      spaceBetween: 0,
      navigation: {
        nextEl: this.querySelector(".swiper-button-next"),
        prevEl: this.querySelector(".swiper-button-prev"),
        enabled: false,
      },
      pagination: {
        el: this.querySelector(".swiper-pagination"),
        clickable: true,
        enabled: true,
      },
      // Pour la version non mobile, on n'affiche pas la pagination
      breakpoints: {
        768: {
          pagination: {
            enabled: false,
          },
          navigation: {
            enabled: true,
          },
        },
      },
      on: {
        init: function (swiper) {
          // Si on est en mobile, et le .slider a aussi la class disable_on_mobile, on disable le slider
          if (window.innerWidth < 768 && swiper.el.classList.contains("disable_on_mobile")) {
            swiper.disable();
          }

          // Si on est en desktop, et le .slider a aussi la class without_slider, on disable le slider
          if (window.innerWidth >= 768 && swiper.el.classList.contains("without_slider")) {
            swiper.disable();
          }
        },
        resize: function (swiper) {
          // Si on est en mobile, et le .slider a aussi la class disable_on_mobile, on disable le slider
          if (window.innerWidth < 768 && swiper.el.classList.contains("disable_on_mobile")) {
            swiper.disable();
          }

          // Si on est en desktop, et le .slider a aussi la class without_slider, on disable le slider
          if (window.innerWidth >= 768 && swiper.el.classList.contains("without_slider")) {
            swiper.disable();
          }
        },
      },
    });

    // Pour les éléments de navigation et de pagination, on stop propagation des événements de clic
    this.querySelectorAll(".swiper-button-next, .swiper-button-prev, .swiper-pagination").forEach((element) => {
      element.addEventListener("click", (e) => {
        e.stopPropagation();
      });
    });
  }
}
customElements.define("product-card-swiper", ProductCardSwiper);

// Products list swiper
class Slideshow extends HTMLElement {
  constructor() {
    super();
    this.nbPerSlide = this.dataset.nbPerSlide ? this.dataset.nbPerSlide : 1;
    this.autoplay = this.dataset.autoplay === "true" ? true : false;
    this.navigation = this.dataset.navigation === "true" ? true : false;
    this.pagination = this.dataset.pagination === "true" ? true : false;
    this.stepBetweenSlides = this.dataset.stepBetweenSlides ? this.dataset.stepBetweenSlides : 1;
    this.spaceBetween = this.dataset.spaceBetween ? this.dataset.spaceBetween : 16;

    this.mobileNbPerSlide = this.dataset.mobileNbPerSlide ? this.dataset.mobileNbPerSlide : 1;
    this.mobileNavigation = this.dataset.mobileNavigation === "true" ? true : false;
    this.mobilePagination = this.dataset.mobilePagination === "true" ? true : false;
    this.mobileStepBetweenSlides = this.dataset.mobileStepBetweenSlides ? this.dataset.mobileStepBetweenSlides : 1;
  }

  connectedCallback() {
    this.initializeSlideshow();
  }

  initializeSlideshow() {
    new Swiper(this.querySelector(".swiper"), {
      slidesPerView: this.mobileNbPerSlide === "auto" ? "auto" : parseInt(this.mobileNbPerSlide),
      slidesPerGroup: parseInt(this.mobileStepBetweenSlides),
      spaceBetween: 0,
      loop: true,
      loopAddBlankSlides: true,
      centeredSlides: true,
      autoplay: this.autoplay
        ? {
            enabled: true,
            delay: 3000,
            disableOnInteraction: true,
          }
        : false,
      navigation: {
        nextEl: this.querySelector(".swiper-button-next.slideshow_button_next"),
        prevEl: this.querySelector(".swiper-button-prev.slideshow_button_prev"),
        enabled: this.mobileNavigation,
      },
      pagination: {
        el: this.querySelector(".swiper-pagination.swiper-slideshow-pagination"),
        clickable: true,
        enabled: this.mobilePagination,
        type: "bullets",
      },
      breakpoints: {
        768: {
          slidesPerView: parseInt(this.nbPerSlide),
          slidesPerGroup: parseInt(this.stepBetweenSlides),
          spaceBetween: parseInt(this.spaceBetween),
          centeredSlides: false,
          loop: false,
          freeMode: false,
          navigation: {
            enabled: this.navigation,
          },
          pagination: {
            enabled: this.pagination,
          },
        },
      },
    });
  }
}
customElements.define("slide-show", Slideshow);

// Collapsible content
class CollapsibleContent extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // Click on collapsible title
    this.addEventListener("click", this.toggleContent.bind(this));

    if (this.getAttribute("data-open") === "true") {
      this.toggleContent();
    }
  }

  toggleContent() {
    this.setAttribute("data-open", this.getAttribute("data-open") === "true" ? "false" : "true");
    $(this.querySelector(".collapsible_content_inner")).slideToggle(200);
  }
}
customElements.define("collapsible-content", CollapsibleContent);

// Custom video player
class CustomVideoPlayer extends HTMLElement {
  constructor() {
    super();

    this.video = this.querySelector("video");
    this.playButton = this.querySelector(".custom_video_play");
    this.pauseButton = this.querySelector(".custom_video_pause");
    this.controls = this.querySelector(".custom_controls");
  }

  connectedCallback() {
    this.addEventListener("click", this.handlePlayPause.bind(this));
  }

  handlePlayPause(event) {
    event.preventDefault();
    if (this.getAttribute("data-playing") === "true") {
      this.video.pause();
      this.setAttribute("data-playing", "false");
    } else {
      this.video.play();
      this.setAttribute("data-playing", "true");
    }
  }
}

customElements.define("custom-video-player", CustomVideoPlayer);

// Popin custom opener
class PopinCustomOpener extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener("click", this.handleClick.bind(this));
  }

  handleClick(event) {
    event.preventDefault();
    const target = this.getAttribute("data-target");
    const popin = document.getElementById(target);
    if (popin) {
      $(popin).find(".popin_overlay").css("display", "flex").hide().fadeIn(200);
    }
  }
}
customElements.define("popin-custom-opener", PopinCustomOpener);

// Popin custom content
class PopinCustomContent extends HTMLElement {
  constructor() {
    super();

    this.closeButton = this.querySelector(".popin_overlay .close");
  }

  connectedCallback() {
    this.closeButton.addEventListener("click", this.handleClose.bind(this));

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        this.handleClose(event);
      }
    });

    this.addEventListener("click", (event) => {
      // Si la target est .popin_overlay, on ferme le popin. Si on clique sur le contenu du popin, on ne ferme pas le popin.
      if (event.target.closest(".popin_overlay") && !event.target.closest(".popin_content_inner")) {
        this.handleClose(event);
      }
    });
  }

  handleClose(event) {
    event.preventDefault();
    $(this).find(".popin_overlay").fadeOut(200);
  }
}
customElements.define("popin-custom-content", PopinCustomContent);

// Back to top
class BackToTop extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener("click", this.handleClick.bind(this));
  }

  handleClick(event) {
    event.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }
}
customElements.define("back-to-top", BackToTop);
